import { CheckCircle2 } from 'lucide-react';

export default function PaymentSuccessPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md rounded-2xl border border-emerald-100 bg-white p-8 text-center shadow-sm">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-emerald-50">
          <CheckCircle2 className="h-8 w-8 text-emerald-600" aria-hidden />
        </div>
        <h1 className="text-xl font-bold text-slate-900">Payment successful</h1>
        <p className="mt-2 text-sm text-slate-600">
          Thank you — your payment has been received. You can close this page.
        </p>
      </div>
    </div>
  );
}
